const baseUrl = process.env.BASE_URL;
module.exports = {
  baseUrl,
};
